import { VideoCallScene } from '../types'

export const generateChannelName = (roomUid: string, scene: VideoCallScene) => {
  // Outbound/Inbound の2クライアントは同一チャンネルで通信する
  if (scene === 'ConnectionTestOutbound' || scene === 'ConnectionTestInbound') {
    return `${roomUid}_ConnectionTest`
  }
  return `${roomUid}_${scene}`
}
